import React from 'react';
import { ProgressStateModel } from 'eTip--common';
import { translationForMts } from 'easit--localization';
import { InfoBox } from 'common--design-library';
import classNames from 'classnames';

export interface IChatComponentProps {
    writeMessageNode: React.ReactNode;
    messageListNode: React.ReactNode;
    state: ProgressStateModel;
    errorMessage: string;

    subscribeMessagesAgain: () => void;
}

export const ChatComponent: React.FC<IChatComponentProps> = (props: IChatComponentProps) => {
    const t = translationForMts();
    return <div className={classNames("chat-wrapper", __IsMTSTipos__ ? "mb-2" : null)}>
        <div className="header">Chat</div>
        <div className="content">
            {
                props.state === ProgressStateModel.Success && <>
                    {!__IsMTSTipos__ && props.writeMessageNode}
                    {props.messageListNode}
                    {__IsMTSTipos__ && props.writeMessageNode}
                </>
            }
            {
                props.state === ProgressStateModel.Loading && <div className="p-2">
                    <span><i className="fa fa-2x fa-spinner fa-spin"></i> {t.chat_LoadingMessages}</span>
                </div>
            }
            {
                props.state === ProgressStateModel.Failed &&
                <InfoBox>
                    {props.errorMessage}
                    <button className={classNames("btn btn-dark", __IsMTSTipos__ ? "mt-2" : null)} onClick={() => { props.subscribeMessagesAgain(); }} >{t.chat_ErrorLoadingMessagesAgainBtn}</button>
                </InfoBox>
            }

        </div>
    </div>;
}